// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___P0U7C","root__save":"style-module__root__save___GXwAt","root__cancel":"style-module__root__cancel___aXeDj"};
    if(module.hot) {
      // 1697460475226
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  